import css from 'styled-jsx/css';
import { screen } from '../variables';

const topModelsByYearCSS = css`
  .container {
    display: flex;
    flex-direction: column;
  }

  .links {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0px;
  }

  @media screen and (min-width: ${screen.smMin}) and (max-width: ${screen.smMax}) {
    .links {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      padding: 0px 0px 0px 60px;
    }
  }

  @media screen and (min-width: ${screen.mdMin}) {
    .links {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      margin-bottom: 20px;
      padding: 0px 0px 0px 60px;
    }
  }
`;

export default topModelsByYearCSS;
